exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stick-below-nav {\n  position: sticky !important;\n  top: 78px !important;\n}\n", ""]);

// exports
